import { render, staticRenderFns } from "./ContactPersonal.vue?vue&type=template&id=6dd33a15"
import script from "./ContactPersonal.vue?vue&type=script&lang=js"
export * from "./ContactPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports